export default __webpack_public_path__ + "static/media/sponsor_ca_primary.9a7e825f.png";